module.exports = __webpack_public_path__ + "img/19.9fdd43cd.png";